var _style, _path, _polygon, _defs, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _circle, _path8, _polygon2, _circle2, _circle3, _path9, _rect2, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMvLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 313.3 60.1",
    style: {
      enableBackground: "new 0 0 313.3 60.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0677FF;}\r\n\t.st1{clip-path:url(#SVGID_00000160896639148560319460000015585214765770271922_);}\r\n\t.st2{fill:url(#SVGID_00000165221747945948067460000002615355250473909125_);}\r\n\t.st3{fill:url(#SVGID_00000160898414956115442470000011452390589551830703_);}\r\n\t.st4{fill:url(#SVGID_00000075121053654782300120000010441550516601557180_);}\r\n\t.st5{fill:#231F20;}\r\n\t.st6{fill:#DD45C7;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.6,44.5l-9.7-23.2l-5.4,2.3l9.7,23.2c0.6,1.3,0.6,2.8,0,4.2s-1.6,2.4-2.9,2.9c-2.8,1.2-5.9-0.2-7.1-2.9 l-9.7-23.2l0,0l-0.2-0.4c-1.5-3.5-4.8-5.7-8.6-5.7l0,0c-3.8,0-7.1,2.2-8.6,5.7L26,27.7l0,0l-9.7,23.2c-1.2,2.8-4.3,4.1-7.1,2.9 c-1.3-0.6-2.4-1.6-2.9-2.9s-0.5-2.8,0-4.2L16,23.5l-5.4-2.3L0.9,44.5c-1.2,2.8-1.2,5.8,0,8.6s3.3,5,6.1,6.1c1.4,0.6,2.9,0.9,4.3,0.9 c4.4,0,8.6-2.6,10.4-6.9l7.4-17.7l0,0l2.5-5.9c0.8-1.9,2.6-2.1,3.2-2.1s2.3,0.2,3.2,2.1l2.5,5.9l0,0l7.4,17.7 c1.8,4.3,6,6.9,10.4,6.9c1.4,0,2.9-0.3,4.3-0.9c2.8-1.2,4.9-3.3,6.1-6.1C69.8,50.3,69.8,47.3,68.6,44.5L68.6,44.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.8,52 19.4,15.4 6.8,45.6 1.4,43.3 19.4,0.1 34.8,36.8 50.1,0.1 68.1,43.3 62.7,45.6 50.1,15.4 "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M68.6,44.5l-9.7-23.2l-5.4,2.3l9.7,23.2c0.6,1.3,0.6,2.8,0,4.2s-1.6,2.4-2.9,2.9c-2.8,1.2-5.9-0.2-7.1-2.9 l-9.9-23.6c-1.5-3.5-4.8-5.7-8.6-5.7l0,0c-3.8,0-7.1,2.2-8.6,5.7L26,27.7l-9.7,23.2c-1.2,2.8-4.3,4.1-7.1,2.9 c-1.3-0.6-2.4-1.6-2.9-2.9s-0.5-2.8,0-4.2L16,23.5l-5.4-2.3L0.9,44.5c-1.2,2.8-1.2,5.8,0,8.6s3.3,5,6.1,6.1 c1.4,0.6,2.9,0.9,4.3,0.9c4.4,0,8.6-2.6,10.4-6.9l7.4-17.7l0,0l2.5-5.9c0.8-1.9,2.6-2.1,3.2-2.1s2.3,0.2,3.2,2.1l2.5,5.9l0,0 l7.4,17.7c1.8,4.3,6,6.9,10.4,6.9c1.4,0,2.9-0.3,4.3-0.9c2.8-1.2,4.9-3.3,6.1-6.1C69.8,50.3,69.8,47.3,68.6,44.5L68.6,44.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000051380622578056718680000011985547083563956114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000051380622578056718680000011985547083563956114_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000062879937999284798600000011899169511530259133_",
    cx: 45.8768,
    cy: -9.1883,
    r: 84.81,
    gradientTransform: "matrix(0.87 0 0 -0.87 -5.728 16.2836)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#DD45C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D447C9",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#BC4CCF",
      stopOpacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#9455D9",
      stopOpacity: 0.83
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#5E62E7",
      stopOpacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#1972F9",
      stopOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0677FF",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000062879937999284798600000011899169511530259133_)"
    },
    cx: 34.4,
    cy: 24.5,
    r: 74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034063310415553723660000005346307576062114197_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.554,
    y1: 68.9119,
    x2: 142.974,
    y2: 95.9419,
    gradientTransform: "matrix(0.9201 0.4166 0.3886 -0.9986 -104.0221 58.2695)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0677FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#0677FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 21.2,
    style: {
      fill: "url(#SVGID_00000034063310415553723660000005346307576062114197_)"
    },
    width: 17.3,
    height: 30.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097469672891506502480000012459468881415115427_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.6512,
    y1: 47.5649,
    x2: 92.0712,
    y2: 74.5949,
    gradientTransform: "matrix(0.9201 0.4166 0.3886 -0.9986 -104.0221 58.2695)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0677FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#0677FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1.6,
    y: 21.2,
    style: {
      fill: "url(#SVGID_00000097469672891506502480000012459468881415115427_)"
    },
    width: 17.3,
    height: 30.3
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M224.9,17.4c-6.4,0-11.1,4.8-11.1,11.5s4.9,11.6,11.9,11.6c3.6,0,6.7-1.3,8.8-3.7l0.4-0.5l-2.6-3l-0.6,0.7 c-1.4,1.7-3.5,2.5-5.9,2.5c-3.9,0-6.8-2.2-7.5-5.7l0-0.1h17.6v-0.8c0-0.2,0-0.3,0-0.4v-0.1c0-0.2,0-0.3,0-0.4 C235.9,22.2,231.3,17.4,224.9,17.4L224.9,17.4z M218.3,26.9L218.3,26.9c0.7-3.4,3.3-5.5,6.6-5.5s6,2.1,6.6,5.4l0,0.1H218.3 L218.3,26.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M123.8,17.4c-6.4,0-11.1,4.8-11.1,11.5s4.9,11.6,11.9,11.6c3.6,0,6.7-1.3,8.8-3.7l0.4-0.5l-2.6-3l-0.6,0.7 c-1.4,1.7-3.5,2.5-5.9,2.5c-3.9,0-6.8-2.2-7.4-5.7l0-0.1h17.6v-0.8c0-0.2,0-0.3,0-0.4v-0.1c0-0.2,0-0.3,0-0.4 C134.9,22.2,130.2,17.4,123.8,17.4L123.8,17.4z M117.2,26.9L117.2,26.9c0.7-3.4,3.3-5.5,6.6-5.5s6,2.1,6.6,5.4l0,0.1H117.2 L117.2,26.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.8,17.4c-6.4,0-11.1,4.8-11.1,11.5s4.9,11.6,11.9,11.6c3.6,0,6.7-1.3,8.8-3.7l0.4-0.5l-2.6-3l-0.6,0.7 c-1.4,1.7-3.5,2.5-5.9,2.5c-3.9,0-6.8-2.2-7.5-5.7l0-0.1h17.6v-0.8c0-0.2,0-0.3,0-0.4v-0.1c0-0.2,0-0.3,0-0.4 C294.9,22.2,290.2,17.4,283.8,17.4L283.8,17.4z M277.2,26.9L277.2,26.9c0.7-3.4,3.3-5.5,6.6-5.5s6,2.1,6.6,5.4l0,0.1H277.2 L277.2,26.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M242.6,28.8V40h-4.5V28.8c0-3.1,1.1-5.7,3.3-7.9s4.8-3.3,7.9-3.3v4.5c-1.9,0-3.4,0.7-4.7,2S242.6,27,242.6,28.8 L242.6,28.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M148.7,17.6c-3.1,0-5.9,1.1-8.1,3.4c-2.2,2.2-3.4,4.9-3.4,8.1s1.1,5.9,3.4,8.1c2.2,2.2,4.9,3.4,8.1,3.4 s5.9-1.1,8.1-3.4c2.2-2.2,3.4-4.9,3.4-8.1V10.9h-4.4V20l-0.1-0.1C153.6,18.3,151.3,17.6,148.7,17.6L148.7,17.6z M153.7,34 c-1.4,1.4-3,2.1-4.9,2.1s-3.6-0.7-4.9-2.1c-1.4-1.4-2.1-3-2.1-4.9s0.7-3.6,2.1-4.9c1.4-1.4,3-2.1,4.9-2.1s3.6,0.7,4.9,2.1 c1.4,1.4,2.1,3,2.1,4.9S155,32.6,153.7,34z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M189.3,21c-2.2-2.2-4.8-3.3-7.9-3.3s-5.8,1.1-7.9,3.3c-2.2,2.2-3.3,4.8-3.3,7.9s1.1,5.7,3.3,7.9 c2.2,2.2,4.8,3.3,7.9,3.3c2.6,0,4.8-0.7,6.7-2.2v2.2h4.5V29C192.6,25.9,191.5,23.2,189.3,21L189.3,21z M186.1,33.7 c-1.3,1.3-2.9,2-4.8,2s-3.4-0.7-4.8-2c-1.3-1.3-2-2.9-2-4.8s0.7-3.4,2-4.8s2.9-2,4.8-2s3.4,0.7,4.8,2c1.3,1.3,2,2.9,2,4.8 S187.4,32.4,186.1,33.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 162.9,
    y: 17.7,
    className: "st5",
    width: 4.4,
    height: 22.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 165.1,
    cy: 12.7,
    r: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.2,17.7h12.2v4.5h-12.2c-0.6,0-1.1,0.2-1.6,0.7s-0.7,1-0.7,1.6s0.2,1.1,0.7,1.6s1,0.7,1.6,0.7h5.5 c1.9,0,3.4,0.7,4.7,2s2,2.9,2,4.7c0,1.8-0.7,3.4-2,4.7s-2.9,2-4.7,2h-12.2v-4.5h12.2c0.6,0,1.1-0.2,1.6-0.7s0.7-1,0.7-1.6 s-0.2-1.1-0.7-1.6c-0.4-0.4-1-0.7-1.6-0.7h-5.5c-1.9,0-3.4-0.7-4.7-2c-1.3-1.3-2-2.9-2-4.7s0.7-3.4,2-4.7S256.4,17.7,258.2,17.7z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "203,31.7 195.8,17.7 191,17.7 203,41 215.2,17.7 210.4,17.7 "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 312.2,
    cy: 15.3,
    r: 1.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 297.8,
    cy: 25.8,
    r: 1.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M307.6,26c-0.8,0.6-1.8,1-2.9,1c-1.4,0-2.5-0.5-3.5-1.4s-1.4-2.1-1.4-3.4s0.5-2.5,1.4-3.4 c1-0.9,2.1-1.4,3.5-1.4s2.5,0.5,3.5,1.4s1.4,2.1,1.4,3.4v4.9h-2V26z M304.7,19.1c-0.8,0-1.5,0.3-2.1,0.9s-0.9,1.3-0.9,2.1 s0.3,1.5,0.9,2.1s1.3,0.9,2.1,0.9s1.5-0.3,2.1-0.9s0.9-1.3,0.9-2.1s-0.3-1.5-0.9-2.1S305.5,19.1,304.7,19.1z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 311.2,
    y: 17.2,
    className: "st6",
    width: 1.9,
    height: 9.8
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.5,17.4c-2.6,0-4.9,1.1-6.6,2.9c-1.6-1.8-3.9-2.9-6.6-2.9c-4.9,0-8.8,4-8.8,8.8v13.9h4.6V26.2 c0-2.4,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3c0,0,0,0,0,0v13.9h4.6V26.2c0,0,0,0,0,0c0-2.3,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3v13.9h4.6 V26.2C110.3,21.3,106.4,17.4,101.5,17.4L101.5,17.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvLogo);
export default __webpack_public_path__ + "static/media/mv_logo.0492b779803679a549c2beb41bbd21a0.svg";
export { ForwardRef as ReactComponent };